// Display metadata for a contact's deliverability status, derived from the
// backend suppression_reason (see business.SuppressionReason*). Lets the
// Contacts table show WHY a contact stopped receiving mail. Color names map to
// Arco Tag colors.
export function suppressionMeta(reason) {
  switch (reason) {
    case "bounced":
      return { label: "Bounced", color: "red" };
    case "complained":
      return { label: "Complained", color: "orangered" };
    case "unsubscribed":
      return { label: "Unsubscribed", color: "gray" };
    default:
      return { label: "Active", color: "green" };
  }
}
